import {
  initialState,
  Actions,
  State,
  GET_EXPERT_INFORMATION,
  GET_EXPERT_INFORMATION_SUCCESS,
  GET_EXPERT_INFORMATION_ERROR,
} from "../../types/expert/get-expert-information";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_EXPERT_INFORMATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_EXPERT_INFORMATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_EXPERT_INFORMATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
